export const onClientEntry = () => {
  if (typeof window === 'undefined') return;
  void import('./src/services/mixpanel').then(({ initMixpanel }) => initMixpanel());
};

export const onRouteUpdate = () => {
  try {
    if (window.FB && window.FB.XFBML) {
      window.FB.XFBML.parse(); // re-scan when navigating between pages
    }
    if (window.FB && window.FB.AppEvents) {
      window.FB.AppEvents.logPageView();
    }
  } catch (error) {
    console.error('Error initializing Facebook SDK:', error);
  }
};
